export default __webpack_public_path__ + "static/media/login-bg.e86494e4.mp4";